import React, { useState, useEffect, useCallback } from 'react'; // Added useCallback
import { Row, Col, Spinner } from 'react-bootstrap'; // Removed Container, Card
import { useNavigate, useParams } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Header from '../../../components/common/Header';
import CourseForm from './CourseForm';
import CourseService from '../../../services/courseService';

const EditCourse = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadCourse = useCallback(async () => {
    try {
      setLoading(true);
      const response = await CourseService.getCourseById(id);
      setCourse(response.data);
    } catch (error) {
      toast.error('Failed to load course details');
      navigate('/admin/courses');
    } finally {
      setLoading(false);
    }
  }, [id, navigate]);

  useEffect(() => {
    loadCourse();
  }, [loadCourse]);

  const handleSuccess = () => {
    navigate('/admin/courses');
  };

  const handleCancel = () => {
    navigate('/admin/courses');
  };

  if (loading) {
    return (
      <div>
        <Header />
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-2">Loading course details...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="container-fluid p-4">
        <Row className="mb-4 align-items-center">
          <Col>
            <div className="d-flex align-items-center">
              <button 
                className="btn btn-outline-secondary me-3"
                onClick={() => navigate('/admin/courses')}
              >
                <FaArrowLeft className="me-2" /> Back
              </button>
              <h2>Edit Course: {course?.name}</h2>
            </div>
            <p className="text-muted">Update the course details below</p>
          </Col>
        </Row>

        <CourseForm 
          course={course}
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
};

export default EditCourse;